document.addEventListener('DOMContentLoaded', () => {
    // Mobile menu toggle
    const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
    
    if(mobileMenuBtn) {
        mobileMenuBtn.addEventListener('click', () => {
            console.log('Mobile menu clicked');
            // Add mobile menu logic later if necessary
        });
    }

    // Custom Tabs Logic
    const initTabs = () => {
        const tabBtns = document.querySelectorAll('.tab-btn');
        const tabPanes = document.querySelectorAll('.tab-pane');

        if(tabBtns.length === 0) return;

        tabBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const targetId = e.currentTarget.getAttribute('data-target');
                
                // Remove active class from all
                tabBtns.forEach(b => b.classList.remove('active'));
                tabPanes.forEach(p => p.classList.remove('active'));

                // Add active class to selected
                e.currentTarget.classList.add('active');
                document.getElementById(targetId).classList.add('active');
            });
        });
    };

    // Initialize tabs when content is dynamically added or on load
    initTabs();
});
